var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('card',{staticClass:"stacked-form"},[(_vm.location)?_c('location-form',{attrs:{"init-location":_vm.location,"val-errors":_vm.valErrors,"submit-text":"Speichern"},on:{"submit":_vm.submit}}):_vm._e()],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }